export default [
  {
    path: '/agreements',
    name: 'agreements',
    component: () => import('@/views/modules/Agreements/index.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.supply',
          active: true,
        },
        {
          text: 'sidebar.agreements',
          active: true,
        }
      ],
    },
  },
  {
    path: '/add-agreements/:id',
    name: 'add-agreements',
    component: () => import('@/views/modules/Agreements/addAgreements.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.supply',
          active: true,
        },
        {
          text: 'sidebar.agreements',
          active: false,
          to: '/agreements',
        },
        {
          text: 'watch',
          active: true,
        },
      ],
    },
  },
  {
    path: '/edit-agreements/:id',
    name: 'edit-agreements',
    component: () => import('@/views/modules/Agreements/editAgreements.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.supply',
          active: true,
        },
        {
          text: 'sidebar.agreements',
          active: false,
          to: '/agreements',
        },
        {
          text: 'watch',
          active: true,
        },
      ],
    },
  },
  {
    path: '/view-agreements/:id',
    name: 'view-agreements',
    component: () => import('@/views/modules/Agreements/viewAgreements.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.supply',
          active: true,
        },
        {
          text: 'sidebar.agreements',
          active: false,
          to: '/agreements',
        },
        {
          text: 'watch',
          active: true,
        },
      ],
    },
  },
]
